import { UTM } from '../utilities/config';

/** 與資安、React dangerouslySetInnerHTML 有關 methods 存放於此
 * note: 前人 code 常用 text.replace(/(?:\r\n|\r|\n)/g, '<br />') 去把文字換行符號改成 <br> 標籤
 * 換行用 CSS white-space 處理換行即可，dangerouslySetInnerHTML 處的 text.replace 應該是用來處理 XSS 危險字元才對..
 */

const LINK_LENGTH = 129;

/** replaceXSSText 僅替換掉可能導致 xss 攻擊文字 不讓保留中文等其他文字被 encode
 * @param {String} str - 欲替換可能導致 xss 攻擊的文字
 * @returns {String} 已被替換文字
 */
export const replaceXSSText = (str = '') => {
  return str.replace(/[<">'&/]/g, dangerText => {
    return {
      '<': '&lt;',
      '&': '&amp;',
      '"': '&quot;',
      '>': '&gt;',
      "'": '&#39;',
      '/': '&#x2F',
    }[dangerText];
  });
};

/** replaceXSSTextButPreserveLink 僅替換掉可能導致 xss 攻擊文字 但是保留 /、&
 * @param {String} str - 欲替換可能導致 xss 攻擊的文字
 * @description 替換掉可能導致 xss 攻擊文字，但若有 https:// 網址前端要處理成 <a> link ，所以 / 和 & 必須保留
 * @returns {String} 已被替換文字
 */
export const replaceXSSTextButPreserveLink = (str = '') => {
  return str.replace(/[<">']/g, dangerText => {
    return {
      '<': '&lt;',
      '"': '&quot;',
      '>': '&gt;',
      "'": '&#39;',
    }[dangerText];
  });
};

/** setUrlLinkFromDescription 從文字段落分離出 <a> Link 與文字並加上自己的 link utm
 * @param {String} description - 包含 a 連結網址的一大串文字字串
 * @description 此 function 先用 replaceXSSTextButPreserveLink 篩掉危險字元但保留 https:// Link 後才置換 Link 文字成 a tag
 * @returns {String} 包含 <a> Link 與分離後的文字字串，且已用 replaceXSSTextButPreserveLink 處理過
 */
export const setUrlLinkFromDescription = description => {
  const safeDescription = replaceXSSTextButPreserveLink(description);

  // find the URL
  const urlMatches = safeDescription.match(/\b(http|https)?:\/\/\S+/gi) || [];
  let text = safeDescription;

  let latestEndIndex = 0;

  // replace url text to <a>
  urlMatches.forEach(link => {
    const startIndex = text.indexOf(link, latestEndIndex);
    const endIndex = startIndex + link.length;
    const setQueryString = link.indexOf('?') > -1 ? '&' : '?';
    const hasUTM = link.indexOf('utm_') > -1;

    const linkWithQueryString = hasUTM
      ? link
      : `${link}${setQueryString}utm_medium=${UTM.MEDIUM}&utm_source=${UTM.SOURCE}`;

    latestEndIndex = endIndex + LINK_LENGTH;

    text = insertTextAtIndices(text, {
      [startIndex]: `<a href="${linkWithQueryString}" target="_blank" rel="noopener noreferrer nofollow" class="embedded-link">`,
      [endIndex]: '</a>',
    });
  });
  return text;
};

const insertTextAtIndices = (text, obj) => {
  let newText = '';
  for (let i = 0; i < text.length; i++) {
    newText += obj[i] ? obj[i] + text[i] : text[i];
  }
  return newText;
};
